import { Languages } from '@remote-voice/utilities';
import { useAtom, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { browserLocale } from '@/locales/i18n';

const subUserLanguageAtom = atomWithStorage<Languages>(
    'RV_USER_GUEST_LANGUAGE',
    browserLocale
);

const useSubUserLanguage = () => useAtom(subUserLanguageAtom)[0];
export const useSetSubUserLanguage = () => {
    const atom = useSetAtom(subUserLanguageAtom);
    return (language: Languages) => {
        atom(language);
    };
};
export default useSubUserLanguage;
